<template>
  <div>
    <a-row>
      <g-master name="project_task_person"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                modalWidth="80%"
      >
         <span slot="estadoRenderer" slot-scope="{text}">
          <a-tag :color="text==='PENDIENTE' ? 'red' : (text === 'COMPLETO' ? 'green' : 'blue')">{{text}}</a-tag>
        </span>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <g-lookup endpoint="usuarios"
                          :label="$t('Asignar tarea a')"
                          :formItemConfig="fiOptions"
                          :cache="false"
                          :decorator="['id_project_persona', { rules: [{ required: true }] }]"
                          ref="user">
              </g-lookup>
            </a-col>
          </a-row>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado el', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado el', column: 'modified_on'}
          ],
          actions: {
            actions: [
              {
                name: 'masterEdit',
                text: 'Editar',
                permisos: [],
                props: {size: 'small', type: 'link', icon: 'edit'}
              },
              {
                name: 'masterDelete',
                text: 'Eliminar',
                permisos: [],
                props: {size: 'small', icon: 'delete', type: 'link'}
              }
            ]
          },
          endpoint: 'project_task_person',
          tableSetup: {
            customSlots: ['estadoRenderer', 'expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Tarea Asignada Al Usuario', dataIndex: 'persona', sorter: true},
              {title: 'Comentarios Del Usuario Que Realizo La Tarea', dataIndex: 'comments', sorter: true, width: 500},
              {title: 'Fecha Inicio Tarea', dataIndex: 'f_ini', sorter: true},
              {title: 'Fecha Fin Tarea', dataIndex: 'f_fin', sorter: true},
              {
                title: 'Estado',
                dataIndex: 'estado',
                width: 110,
                sorter: true,
                scopedSlots: {
                  filterDropdown: 'filterDropdown',
                  filterIcon: 'filterIcon',
                  customRender: 'estadoRenderer'
                }
              }
            ]
          }
        }
      }
    },
    props: ['id_task_detail'],
    computed: {
      parentData () {
        return {
          id_task_detail: this.id_task_detail
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/GestionDeProyectos/ProjectTaskPersonAdmin.vue